import React from "react";
import "./JobSemless.css";
import Seamless from "../Images/Seamless.png";

const JobSourcing = () => {
  return (
    <div className="job-sourcing-container">
      <h2>
        Seamless <span>Job Sourcing</span>
      </h2>
      <p>
        We connect job seekers with top-tier companies from a wide range of industries. Whether you're looking to join a fast-growing startup or a global enterprise, we’ve got opportunities that match your ambition.
      </p>

      <div className="job-image-wrapper">
        <img src={Seamless} alt="Seamless Job Sourcing Flow" />
      </div>
    </div>
  );
};

export default JobSourcing;
